import { render, staticRenderFns } from "./DetailAddFlow.vue?vue&type=template&id=98f31b48&scoped=true&"
import script from "./DetailAddFlow.vue?vue&type=script&lang=js&"
export * from "./DetailAddFlow.vue?vue&type=script&lang=js&"
import style0 from "./DetailAddFlow.vue?vue&type=style&index=0&id=98f31b48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f31b48",
  null
  
)

export default component.exports